var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddSubTaskDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79079 0.219658C10.0697 0.512535 10.0697 0.987437 9.79079 1.28031L5.50506 5.78034C5.22613 6.07322 4.77385 6.07322 4.49492 5.78034L0.209197 1.28031C-0.0697318 0.987437 -0.0697317 0.512534 0.209197 0.219657C0.488126 -0.0732196 0.940413 -0.0732196 1.21934 0.219657L4.99999 4.18936L8.78063 0.219658C9.05958 -0.0732193 9.51184 -0.0732192 9.79079 0.219658Z",
    fill: "#535252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSubTaskDownArrow);
export default __webpack_public_path__ + "static/media/addSubTaskDownArrow.112e243661bff57b4a29f0f625f44294.svg";
export { ForwardRef as ReactComponent };